import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";
import {
  STATE_IDENTIFIER,
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
} from "./constants";

const {
  OFFICES,
  SELECTED_OFFICE,
  STEP_ONE,
  STEP_TWO,
  BUSINESS_ROLES,
  SELECTED_BR,
  SELECTED_BR_ENTITLEMENTS,
  BR,
  NAME,
  DESCRIPTION,
  ENTITLEMENTS,
  CHAIN_ENTITLEMENTS,
  REQUEST_STATE,
  SOD_CONFLICTS_BR,
} = STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [SELECTED_OFFICE]: {},
  [SELECTED_BR]: {},
  [SELECTED_BR_ENTITLEMENTS]: {
    [LOADER_IDENTIFIER]: false,
    [LIST_IDENTIFIER]: [],
  },
  [ENTITLEMENTS]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
  [STEP_ONE]: {
    [OFFICES]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
  },
  [STEP_TWO]: {
    [BUSINESS_ROLES]: { [LIST_IDENTIFIER]: [], [LOADER_IDENTIFIER]: false },
    [REQUEST_STATE]: IResponseState.PENDING,
  },
  [BR]: {
    [NAME]: "",
    [DESCRIPTION]: "",
    [ENTITLEMENTS]: [],
    [CHAIN_ENTITLEMENTS]: [],
    [REQUEST_STATE]: IResponseState.PENDING,
  },
  [SOD_CONFLICTS_BR]: null,
};
